import { HTMLAttributes } from 'react'
import parse from 'html-react-parser'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'

import { cn } from '@/lib/utils'

export type FreeTextProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme?: 'dark' | 'light'
    className: string
    content: string
  }>

const FreeText = ({ className, content }: FreeTextProps) => {
  return (
    <Container>
      <Grid>
        <div
          data-free-text
          className={cn([
            'col-span-4 md:col-span-10 md:col-start-2',
            className
          ])}
        >
          {parse(content || '')}
        </div>
      </Grid>
    </Container>
  )
}

export default FreeText
